import { } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styles from "./BurgerMenu.module.css";
import { useHaptic } from "../hooks/useHaptic";
import { useGame } from "../store/game";
import { formatInt } from "../lib/format";

type Section = "tasks" | "boosts" | "rewards" | "rating" | "about" | "frens" | "leaderboard" | "autobot";

const ITEMS: { key: Section; icon: string; label: string; subtitle: string }[] = [
  { key: "tasks",       icon: "✓",  label: "Tasks",       subtitle: "Завдання · запроси друзів" },
  { key: "frens",       icon: "🫂", label: "Frens",       subtitle: "Реферали · заробляй GT" },
  { key: "leaderboard", icon: "🏆", label: "Рейтинг",     subtitle: "Топ-10: 500 GT/тиж · Топ-100: 200 GT" },
  { key: "autobot",     icon: "🤖", label: "Авто-бот",    subtitle: "Бот ставить поки ти офлайн · 100 GT/год" },
  { key: "rewards",     icon: "★",  label: "Rewards",     subtitle: "Бусти · скіни · аірдроп" },
];

export function BurgerMenu() {
  const activeModal = useGame((s) => s.activeModal);
  const openModal = useGame((s) => s.openModal);
  const closeModal = useGame((s) => s.closeModal);
  const tokens = useGame((s) => s.tokens);
  const haptic = useHaptic();

  const open = activeModal === "menu";
  const close = () => { if (activeModal === "menu") closeModal(); };

  const handleItem = (key: Section) => {
    haptic.select();
    closeModal(); // close menu first
    setTimeout(() => openModal(key as any), 120);
  };

  return (
    <>
      <button
        type="button"
        className={styles.button}
        onClick={() => {
          haptic.select();
          openModal("menu");
        }}
        aria-label="Open menu"
      >
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              className={styles.backdrop}
              onClick={close}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.18 }}
            />
            <motion.div
              className={styles.sheet}
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 320, damping: 36 }}
              drag="y"
              dragConstraints={{ top: 0, bottom: 0 }}
              dragElastic={{ top: 0, bottom: 0.4 }}
              onDragEnd={(_, info) => {
                if (info.offset.y > 100 || info.velocity.y > 500) close();
              }}
            >
              <span className={styles.handle} />
              <h2 className={styles.title}>Menu</h2>

              <div className={styles.list}>
                {ITEMS.map((it) => (
                  <button
                    key={it.key}
                    type="button"
                    className={styles.item}
                    onClick={() => handleItem(it.key)}
                  >
                    <span className={styles.icon}>{it.icon}</span>
                    <span className={styles.body}>
                      <span className={styles.label}>{it.label}</span>
                      <span className={styles.subtitle}>{it.subtitle}</span>
                    </span>
                    {it.key === "rewards" ? (
                      <span className={styles.gtCounter}>
                        {formatInt(tokens)} GT
                      </span>
                    ) : (
                      <span className={styles.chevron}>›</span>
                    )}
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
